import { Activity, Brain, ClipboardList, History as HistoryIcon, Home, MessageSquare, Stethoscope, User, X } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { useGlobalContext } from '@/store';
import { apiClient } from '@/api/client';

export function Sidebar() {
  const { sidebarOpen, toggleSidebar, patient } = useGlobalContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [isValidated, setIsValidated] = useState(false);

  useEffect(() => {
    if (sidebarOpen && patient?.email && patient?.consultationToken) {
      apiClient
        .get('/patients/by-email', {
          params: {
            email: patient.email,
            name: patient.name,
            consultation_token: patient.consultationToken,
          },
        })
        .then((res) => {
          setIsValidated(Boolean(res.data?.validated));
        })
        .catch(() => setIsValidated(false));
    } else if (!sidebarOpen) {
      // No hacer fetch si el sidebar no está abierto
    } else {
      setIsValidated(false);
    }
  }, [sidebarOpen, patient?.email, patient?.name, patient?.consultationToken]);

  const menuItems = [
    { text: 'Home', icon: <Home size={18} />, path: '/' },
    { text: 'Personal Data', icon: <User size={18} />, path: '/account' },
    { text: 'Case Description', icon: <MessageSquare size={18} />, path: '/description', isConsultationStep: true },
    { text: 'Physical Symptoms', icon: <Stethoscope size={18} />, path: '/physical-symptom', isConsultationStep: true },
    { text: 'Mental Symptoms', icon: <Brain size={18} />, path: '/mind', isConsultationStep: true },
    { text: 'Symptom Selection', icon: <ClipboardList size={18} />, path: '/intake', isConsultationStep: true },
    { text: 'Results', icon: <Activity size={18} />, path: '/results' },
    { text: 'History', icon: <HistoryIcon size={18} />, path: '/history' },
  ];

  const handleNavigation = (path: string, disabled: boolean) => {
    if (disabled) return;
    navigate(path);
    if (sidebarOpen) toggleSidebar();
  };

  if (!sidebarOpen) return null;

  return (
    <div className="fixed inset-0 z-40 flex">
      <div
        className="fixed inset-0 bg-black/40"
        onClick={toggleSidebar}
        aria-hidden="true"
      />
      <aside className="relative z-50 h-full w-72 bg-base-100 shadow-xl flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-base-300">
          <div className="flex items-center gap-2 text-primary">
            <Stethoscope size={20} />
            <span className="font-semibold">Clinical menu</span>
          </div>
          <button
            type="button"
            className="btn btn-ghost btn-sm btn-square"
            aria-label="Close menu"
            onClick={toggleSidebar}
          >
            <X size={18} />
          </button>
        </div>
        <ul className="menu menu-lg w-full p-2 flex-1 overflow-y-auto">
          {menuItems.map((item) => {
            const active = location.pathname === item.path;
            const disabled = Boolean(isValidated && item.isConsultationStep);
            return (
              <li key={item.text}>
                <button
                  type="button"
                  disabled={disabled}
                  onClick={() => handleNavigation(item.path, disabled)}
                  className={`${active ? 'active text-primary' : ''} ${
                    disabled ? 'opacity-40 text-base-content/40 cursor-not-allowed pointer-events-none' : ''
                  }`}
                >
                  {item.icon}
                  <span>{item.text}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </aside>
    </div>
  );
}
